import React, { useState } from 'react';
import { motion } from "motion/react";
import { EyeIcon, EyeSlashIcon } from './Icons';

interface PasswordInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  value,
  onChange,
  error,
  placeholder
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const getInputClasses = () => {
    const baseClasses = "w-full px-4 py-3 pr-12 bg-gray-900/50 border rounded-2xl text-white placeholder:text-gray-500 focus:outline-none focus:ring-2 transition-all duration-300";
    
    if (error) {
      return `${baseClasses} border-red-500 focus:ring-red-500/50`;
    }
    
    return `${baseClasses} border-gray-700 focus:ring-blue-500/50 focus:border-blue-500`;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <label className="block text-sm font-medium text-gray-300 mb-2">
        {label}
      </label>
      <div className="relative">
        <motion.div whileFocus={{ scale: 1.02 }} transition={{ duration: 0.2 }}>
          <input
            type={showPassword ? 'text' : 'password'}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={getInputClasses()}
          />
        </motion.div>
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute right-4 top-3 text-gray-400 hover:text-gray-300 transition-colors"
        >
          {showPassword ? (
            <EyeSlashIcon className="w-5 h-5" />
          ) : (
            <EyeIcon className="w-5 h-5" />
          )}
        </button>
      </div>
      {error && (
        <motion.p 
          className="text-red-400 text-sm mt-1"
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
        >
          {error}
        </motion.p>
      )}
    </motion.div>
  );
};
